
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { FormValuesEdit } from "../../types";

interface NumberInputProps {
  form: UseFormReturn<FormValuesEdit>;
  name: "max_respuestas" | "report_lifetime";
  label: string;
  placeholder: string;
}

export function NumberInput({ form, name, label, placeholder }: NumberInputProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input
              type="number"
              placeholder={placeholder}
              {...field}
              value={field.value || ""}
              onChange={(e) => field.onChange(Number(e.target.value) || 0)}
              className="w-full"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
